import Component from '../inherited/Component'

export default class AnnouncementBar extends Component {
  constructor (elem, theme, options, ctx) {
    super(elem, theme, options, ctx)
    this._announcementBar = this._elem.querySelector('.announcement-bar')
  }

  mount () {
    if (this._options.sticky) {

      window.addEventListener('scroll', e => {
        let sticky = this._announcementBar.offsetTop
        
        if (window.pageYOffset > sticky) {
          this._announcementBar.classList.add("sticky");
        } else {
          this._announcementBar.classList.remove("sticky");
        }
      }, { passive: true })
    }
  }
}